import Spline from '@splinetool/react-spline';

export default function Test3DPage() {
  return (
    <Spline scene="https://prod.spline.design/EZV6vCBVIka2BPp6/scene.splinecode" />
  );
}
